import(/* webpackMode: "eager" */ "/app/app/(app)/privacy/page.tsx");
